/**
 * 新闻路由模块
 * 包含新闻列表、详情、发布、管理等页面
 */

// 显式导入组件，避免 webpack 无法解析动态路径
const children = [
  {
    path: 'list',
    name: 'news_list',
    url: '/news/list',
    meta: { title: '新闻列表', requiresAuth: false },
    component: () => import(/* webpackChunkName: "news" */ '@/views/news/list.vue')
  },
  {
    path: 'detail/:id',
    name: 'news_detail',
    url: '/news/detail',
    meta: { title: '新闻详情', requiresAuth: false },
    component: () => import(/* webpackChunkName: "news" */ '@/views/news/detail.vue')
  },
  {
    path: 'publish',
    name: 'news_publish',
    url: '/news/publish',
    meta: { title: '发布新闻', requiresAuth: true, requiresDirector: true },
    component: () => import(/* webpackChunkName: "news" */ '@/views/news/publish.vue')
  },
  {
    path: 'my-list',
    name: 'news_my_list',
    url: '/news/my_list',
    meta: { title: '我的新闻', requiresAuth: true, requiresDirector: true },
    component: () => import(/* webpackChunkName: "news" */ '@/views/news/my_list.vue')
  }
]

export default {
  path: '/news',
  name: 'news',
  meta: { title: '新闻中心' },
  component: () => import('@/layout/user.vue'),
  children: children
}
